import SelectColumn from 'components/SelectColumn';
import { useMemo } from 'react';
import { getPaymentStatusOfSeasonPlayerRegistration, getStatusColor } from 'utils/status';

const PaymentStatusColumn = ({ record, isAdmin, canEdit, onPaymentStatusChange }) => {
  const currentStatus = getPaymentStatusOfSeasonPlayerRegistration(record);
  const onChangeAsync = useMemo(() => (newStatus) => onPaymentStatusChange(record, newStatus), [record, onPaymentStatusChange]);

  if (isAdmin && canEdit && record.Season?.playerRegFeeMandatory) {
    const backgroundColor = getStatusColor(currentStatus, 'SeasonPlayerRegistration') === 'green' ? '#f6ffed' :
      getStatusColor(currentStatus, 'SeasonPlayerRegistration') === 'orange' ? '#fff7e6' : 'transparent';
    const textColor = currentStatus === 'PAID' ? '#52c41a' :
      currentStatus === 'UNPAID' ? '#fa8c16' :
        currentStatus === 'FREE' ? '#52c41a' : '#000';

    return (
      <SelectColumn
        value={currentStatus}
        onChangeAsync={onChangeAsync}
        options={[
          { value: 'PAID', label: 'PAID', style: { color: '#52c41a', fontWeight: '400' } },
          { value: 'UNPAID', label: 'UNPAID', style: { color: '#fa8c16', fontWeight: '400' } },
        ]}
        style={{ width: '100%', backgroundColor: backgroundColor, '--select-color': textColor }}
        className="payment-status-select"
        dropdownStyle={{ zIndex: 1000 }}
        size="small"
      />
    );
  } else {
    // Show read-only status tag for non-editable users
    const textColor = currentStatus === 'PAID' ? '#52c41a' :
      currentStatus === 'UNPAID' ? '#fa8c16' :
        currentStatus === 'FREE' ? '#52c41a' : '#000';
    
    return (
      <span style={{ color: textColor, fontWeight: '500' }}>
        {currentStatus}
      </span>
    );
  } 
};

export default PaymentStatusColumn;
